import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoNotificationSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 483.535,
	height: 294.918,
	viewBox: "0 0 483.535 294.918",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_12969",
			"data-name": "Rectangle 12969",
			width: 59.861,
			height: 56.331,
			fill: "#899bfa"
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_8152",
		"data-name": "Group 8152",
		transform: "translate(-1061.815 -353.8)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_1099",
				"data-name": "Path 1099",
				d: "M-1156.243,1154.887s-59.407-70.23-10.046-146.264c43.8-67.463,89.67-40.006,132.441-24.734,31.019,11.076,61.841-9.3,101-77.95,53.4-93.614,238.488-36.836,204.74,107.191-16.332,69.7,49.7,72.232,16.056,141.9Z",
				transform: "translate(2247.71 -506.317)",
				fill: "#c3c2f2",
				opacity: .197
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_1183",
				"data-name": "Group 1183",
				transform: "translate(1204.352 397.352)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1171",
						"data-name": "Group 1171",
						transform: "translate(0 20.313)",
						children: /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_9999",
							"data-name": "Rectangle 9999",
							width: 200.306,
							height: 203.622,
							transform: "translate(200.306 203.622) rotate(180)",
							fill: "#e5eff9"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1172",
						"data-name": "Group 1172",
						transform: "translate(0 0)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Rectangle_10000",
							"data-name": "Rectangle 10000",
							d: "M0,0H200.306a0,0,0,0,1,0,0V11.849a6.386,6.386,0,0,1-6.386,6.386H6.386A6.386,6.386,0,0,1,0,11.849V0A0,0,0,0,1,0,0Z",
							transform: "translate(200.306 18.236) rotate(180)",
							fill: "#032478"
						})
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1173",
						"data-name": "Group 1173",
						transform: "translate(0 20.313)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_10001",
								"data-name": "Rectangle 10001",
								width: 3.215,
								height: 203.622,
								transform: "translate(47.468)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_10002",
								"data-name": "Rectangle 10002",
								width: 3.215,
								height: 200.306,
								transform: "translate(0 155.301) rotate(-90)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_10003",
								"data-name": "Rectangle 10003",
								width: 3.215,
								height: 200.306,
								transform: "translate(0 103.305) rotate(-90)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_10004",
								"data-name": "Rectangle 10004",
								width: 3.215,
								height: 200.306,
								transform: "translate(0 51.536) rotate(-90)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_10005",
								"data-name": "Rectangle 10005",
								width: 3.214,
								height: 203.622,
								transform: "translate(98.546)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_10006",
								"data-name": "Rectangle 10006",
								width: 3.215,
								height: 203.622,
								transform: "translate(149.623)",
								fill: "#f2f9ff"
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1174",
						"data-name": "Group 1174",
						transform: "translate(151.445 181.665)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1929",
							"data-name": "Path 1929",
							d: "M-1339.286,1370.391s-.03,19.567-4.616,36.153l-9.776,6.119h-34.469c6.549-17.427,6.589-42.272,6.589-42.272Z",
							transform: "translate(1388.147 -1370.391)",
							fill: "#7284b4"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1930",
							"data-name": "Path 1930",
							d: "M-1348.662,1417.9v-6.26h9.776Z",
							transform: "translate(1383.131 -1375.632)",
							fill: "#7284b4"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1175",
						"data-name": "Group 1175",
						transform: "translate(98.402 128.887)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1931",
							"data-name": "Path 1931",
							d: "M-1391.391,1318.284s-.03,19.567-4.616,36.154l-9.775,6.119h-34.469c6.549-17.427,6.588-42.272,6.588-42.272Z",
							transform: "translate(1440.251 -1318.284)",
							fill: "#7284b4"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1932",
							"data-name": "Path 1932",
							d: "M-1400.766,1365.8v-6.26h9.776Z",
							transform: "translate(1435.235 -1323.525)",
							fill: "#7284b4"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1176",
						"data-name": "Group 1176",
						transform: "translate(98.402 20.313)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1933",
							"data-name": "Path 1933",
							d: "M-1391.391,1214.305s-.03,19.567-4.616,36.153l-9.775,6.119h-34.469c6.549-17.427,6.588-42.272,6.588-42.272Z",
							transform: "translate(1440.251 -1214.305)",
							fill: "#7284b4"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1934",
							"data-name": "Path 1934",
							d: "M-1400.766,1261.818v-6.26h9.776Z",
							transform: "translate(1435.235 -1219.546)",
							fill: "#7284b4"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1181",
						"data-name": "Group 1181",
						transform: "translate(45.358 76.344)",
						children: [/* @__PURE__ */ _jsxs("g", {
							id: "Group_1177",
							"data-name": "Group 1177",
							children: [/* @__PURE__ */ _jsx("path", {
								id: "Path_1935",
								"data-name": "Path 1935",
								d: "M-1443.495,1266.409s-.03,19.567-4.616,36.154l-9.776,6.119h-34.469c6.549-17.427,6.588-42.273,6.588-42.273Z",
								transform: "translate(1492.356 -1266.409)",
								fill: "#e3e4e5"
							}), /* @__PURE__ */ _jsx("path", {
								id: "Path_1936",
								"data-name": "Path 1936",
								d: "M-1452.871,1313.923v-6.26h9.776Z",
								transform: "translate(1487.34 -1271.65)",
								fill: "#ccc"
							})]
						}), /* @__PURE__ */ _jsxs("g", {
							id: "Group_1180",
							"data-name": "Group 1180",
							transform: "translate(18.508 13.36)",
							children: [/* @__PURE__ */ _jsx("g", {
								id: "Group_1178",
								"data-name": "Group 1178",
								transform: "translate(6.794)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_1937",
									"data-name": "Path 1937",
									d: "M-1462.39,1297.267a.982.982,0,0,1-.982-.982V1282.7a.982.982,0,0,1,.982-.982.983.983,0,0,1,.983.982v13.589A.983.983,0,0,1-1462.39,1297.267Z",
									transform: "translate(1463.372 -1281.713)",
									fill: "#899bfa"
								})
							}), /* @__PURE__ */ _jsx("g", {
								id: "Group_1179",
								"data-name": "Group 1179",
								transform: "translate(0 6.794)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_1938",
									"data-name": "Path 1938",
									d: "M-1456.584,1291.461h-13.589a.982.982,0,0,1-.982-.982.982.982,0,0,1,.982-.983h13.589a.983.983,0,0,1,.983.983A.983.983,0,0,1-1456.584,1291.461Z",
									transform: "translate(1471.155 -1289.496)",
									fill: "#899bfa"
								})
							})]
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1182",
						"data-name": "Group 1182",
						transform: "translate(151.445 128.887)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1939",
							"data-name": "Path 1939",
							d: "M-1339.286,1318.284s-.03,19.567-4.616,36.154l-9.776,6.119h-34.469c6.549-17.427,6.589-42.272,6.589-42.272Z",
							transform: "translate(1388.147 -1318.284)",
							fill: "#e3e4e5"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1940",
							"data-name": "Path 1940",
							d: "M-1348.662,1365.8v-6.26h9.776Z",
							transform: "translate(1383.131 -1323.525)",
							fill: "#e3e4e5"
						})]
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_1217",
				"data-name": "Group 1217",
				transform: "translate(1183.67 462.645)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1187",
						"data-name": "Group 1187",
						transform: "translate(0.07 86.759)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1186",
							"data-name": "Group 1186",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_1185",
								"data-name": "Group 1185",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_1944",
									"data-name": "Path 1944",
									d: "M-1553.953,1337.3a6.147,6.147,0,0,1,.794,2.1,10.1,10.1,0,0,0,.971,2.483,23.626,23.626,0,0,1,1.18,4.138,19.032,19.032,0,0,0-.557,2.77c.094.6.437,1.787-.1,1.865s-1.148-.895-1.148-.895a.792.792,0,0,1-.4.763,1.334,1.334,0,0,1-1.354.049s-.326.607-.737.689a1.668,1.668,0,0,1-1.347-.182,1.628,1.628,0,0,1-1.023.328,1.338,1.338,0,0,1-1.134-.705s-1.012.2-1.306-.267a4.536,4.536,0,0,1-.364-1.4,16.345,16.345,0,0,1,1.283-7.073,6.266,6.266,0,0,0-.334-5.493Z",
									transform: "translate(1560.522 -1336.468)",
									fill: "#eea886"
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1189",
						"data-name": "Group 1189",
						transform: "translate(0 94.586)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1188",
							"data-name": "Group 1188",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1945",
								"data-name": "Path 1945",
								d: "M-1552.682,1350.542s.09-3.467-.822-4.2-1.016.512-1.016.512.124-1.236-.873-1.4-1.039,1.3-1.039,1.3a.963.963,0,0,0-1.21-.757c-1.047.2-.8,1.412-.8,1.412s-1-1.193-1.649-.048a5.27,5.27,0,0,0-.1,4.239s.348.567,1.344.311a1.388,1.388,0,0,0,2.168.391s1.57.849,2.126-.5A1.279,1.279,0,0,0-1552.682,1350.542Z",
								transform: "translate(1560.603 -1345.434)",
								fill: "#db9c7c"
							})
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_1946",
						"data-name": "Path 1946",
						d: "M-1542.171,1279.047s-5.933,19.776-7.938,27.07c-.629,2.288-2.151,24.135-2.419,25.015s-7.795,2.085-7.795,2.085.911-27.331,1-28.823,8.3-32.013,10.695-33.1c1.79-.815,2.736-.141,4.992,1.535C-1540.471,1275.179-1542.171,1279.047-1542.171,1279.047Z",
						transform: "translate(1560.567 -1241.385)",
						fill: "#384c9e"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1190",
						"data-name": "Group 1190",
						transform: "translate(76.261 1.071)",
						children: /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_10007",
							"data-name": "Rectangle 10007",
							width: 16.232,
							height: 1.206,
							transform: "translate(0 8.887) rotate(-33.197)",
							fill: "#4da8f2"
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_1947",
						"data-name": "Path 1947",
						d: "M-1456.723,1243.56a3.541,3.541,0,0,1-.35,1.077s-.444.53-.738.925a3.6,3.6,0,0,0-.213.315,6.483,6.483,0,0,1-1.122,1.744c-.647.656-3.166,2.743-3.166,2.743l-2.159-1.832-2.241-1s1.255-5.454,1.787-6.135a2.141,2.141,0,0,1,.162-.186,8.235,8.235,0,0,1,1.4-.966c.11-.091,1.263-.922,1.674-.814a1.389,1.389,0,0,1,1.035.865,3.318,3.318,0,0,1,1.535.986,2.065,2.065,0,0,1,1.335,1.239S-1456.767,1242.917-1456.723,1243.56Z",
						transform: "translate(1548.674 -1237.379)",
						fill: "#efaa88"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1192",
						"data-name": "Group 1192",
						transform: "translate(6.475 172.204)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1191",
							"data-name": "Group 1191",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1948",
								"data-name": "Path 1948",
								d: "M-1546.078,1434.832s-.54,3.754-.608,4.318-6.016-.332-6.016-.332l-.482-4.469S-1546.822,1434.3-1546.078,1434.832Z",
								transform: "translate(1553.185 -1434.348)",
								fill: "#424773"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1194",
						"data-name": "Group 1194",
						transform: "translate(5.545 176.275)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1193",
							"data-name": "Group 1193",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1949",
								"data-name": "Path 1949",
								d: "M-1546.758,1439.266a16.071,16.071,0,0,0,3.707,3.248c1.824.986,4.689,1.376,5.767,2.4.778.737,2.833,3.908-4.738,3.844s-11.223.448-12.034-.768,1.174-8.977,1.174-8.977S-1551.088,1439.656-1546.758,1439.266Z",
								transform: "translate(1554.25 -1439.011)",
								fill: "#292c47"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1196",
						"data-name": "Group 1196",
						transform: "translate(49.102 172.204)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1195",
							"data-name": "Group 1195",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1950",
								"data-name": "Path 1950",
								d: "M-1497.247,1434.832s-.541,3.754-.608,4.318-6.017-.332-6.017-.332l-.482-4.469S-1497.991,1434.3-1497.247,1434.832Z",
								transform: "translate(1504.355 -1434.348)",
								fill: "#424773"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1198",
						"data-name": "Group 1198",
						transform: "translate(48.172 176.275)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1197",
							"data-name": "Group 1197",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1951",
								"data-name": "Path 1951",
								d: "M-1497.928,1439.266a16.066,16.066,0,0,0,3.708,3.248c1.823.986,8.532,1.8,9.609,2.816.779.737,2.073,3.7-8.581,3.425-7.569-.2-11.222.448-12.034-.768s1.174-8.977,1.174-8.977S-1502.362,1439.7-1497.928,1439.266Z",
								transform: "translate(1505.42 -1439.011)",
								fill: "#292c47"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1200",
						"data-name": "Group 1200",
						transform: "translate(5.545 76.221)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1199",
							"data-name": "Group 1199",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1952",
								"data-name": "Path 1952",
								d: "M-1541.286,1324.4s-5.59,8.881-5.173,16.91-2.027,16.793-2.867,25.18c-.936,9.349-4.767,31.484-4.906,36.484s.594,20.971.594,20.971l7.669.175s6.442-38.7,8.109-42.644,9.941-32.1,10.219-35.254S-1541.286,1324.4-1541.286,1324.4Z",
								transform: "translate(1554.25 -1324.396)",
								fill: "#292c47"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1202",
						"data-name": "Group 1202",
						transform: "translate(15.695 74.691)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1201",
							"data-name": "Group 1201",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1953",
								"data-name": "Path 1953",
								d: "M-1510.383,1325.377s4.213,22,4.769,26.918.927,23.778,1.2,26.849,2.6,40.095,3.336,44.75h-9.8s-7.527-26.982-7.527-39.748-5.815-27.753-9.568-36.176-12.344-8.622-14.652-24.25C-1542.623,1323.719-1513.506,1320.421-1510.383,1325.377Z",
								transform: "translate(1542.623 -1322.644)",
								fill: "#292c47"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1204",
						"data-name": "Group 1204",
						transform: "translate(23.141 0.864)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1203",
							"data-name": "Group 1203",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1954",
								"data-name": "Path 1954",
								d: "M-1529.4,1238.76s7.5-2.8,10.963,2.91,3.127,17.146-.656,18.551-9.463.671-11.4-2.9-3.685-8.741-3.6-12.193S-1531.368,1239.757-1529.4,1238.76Z",
								transform: "translate(1534.094 -1238.073)",
								fill: "#eea886"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1206",
						"data-name": "Group 1206",
						transform: "translate(25.278 16.153)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1205",
							"data-name": "Group 1205",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1955",
								"data-name": "Path 1955",
								d: "M-1519.595,1262.708a6.493,6.493,0,0,0,.2,3.024c.516,1-9.721,1.024-9.721,1.024a67.46,67.46,0,0,0-2.406-10.015C-1533.093,1252.155-1519.595,1262.708-1519.595,1262.708Z",
								transform: "translate(1531.646 -1255.586)",
								fill: "#eea886"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1208",
						"data-name": "Group 1208",
						transform: "translate(22.517)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1207",
							"data-name": "Group 1207",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1956",
								"data-name": "Path 1956",
								d: "M-1531.919,1254.39s.706,1.165,3.59.713,6.4-4.289,7.606-4.71,1.216-1.129,1.216-1.129l.753,1.1,1.28.08s-1.167-3.432.593-4.832-1.826-11.109-11.075-7.877c0,0-7.1,1.958-6.846,6S-1533.509,1252.378-1531.919,1254.39Z",
								transform: "translate(1534.809 -1237.083)"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1210",
						"data-name": "Group 1210",
						transform: "translate(26.644 23.373)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1209",
							"data-name": "Group 1209",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1957",
								"data-name": "Path 1957",
								d: "M-1518.584,1266.662s-.032-1.906-.9-2.09-9.54-1.017-10.6-.6v2.221S-1528.037,1267.451-1518.584,1266.662Z",
								transform: "translate(1530.081 -1263.857)",
								fill: "#e2d2ca"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1212",
						"data-name": "Group 1212",
						transform: "translate(34.932 9.24)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1211",
							"data-name": "Group 1211",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1958",
								"data-name": "Path 1958",
								d: "M-1517.891,1249.14c-.161-.677-1.885-2.615-2.545-.54s1,4.862,1.921,4.623S-1517.481,1250.858-1517.891,1249.14Z",
								transform: "translate(1520.587 -1247.667)",
								fill: "#eea886"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1214",
						"data-name": "Group 1214",
						transform: "translate(10.459 9.19)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1213",
							"data-name": "Group 1213",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1959",
								"data-name": "Path 1959",
								d: "M-1506.591,1267.484c-5.948-.784-14.349-2.887-14.349-2.887l-11.5-.469s-10.551,2.323-14.707,4.2c-.395.178-.4,9.414-1.478,11.836l3.445,7.268s1.99,14.4,2.4,20.8c.19,2.939-4.1,27.565-4.1,27.565a79.431,79.431,0,0,0,12.448,2.219c7.847.865,27.453-.312,27.576-1.239s-3.8-34.51-3.97-36.249c-.266-2.669.92-16.852.92-16.852,1.811-1.406,17.718-8.79,22.058-12.637,1.162-1.03,6.063-5.8,7.457-7.452,4.934-5.834,8.979-10.839,9.472-11.919.559-.614-5.507-3.879-6.044-4.059-.471-.156-6.994,8.533-9.562,11.314a71.934,71.934,0,0,1-5.9,4.7S-1502.87,1267.7-1506.591,1267.484Z",
								transform: "translate(1548.622 -1247.61)",
								fill: "#384c9e"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1216",
						"data-name": "Group 1216",
						transform: "translate(21.359 2.225)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1215",
							"data-name": "Group 1215",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1960",
								"data-name": "Path 1960",
								d: "M-1531.795,1239.632s-9.567.749-.293,15.082Z",
								transform: "translate(1536.135 -1239.632)"
							})
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_1961",
						"data-name": "Path 1961",
						d: "M-1457.024,1239.29l.785-1.2-1.445.189Z",
						transform: "translate(1547.528 -1237.211)",
						fill: "#dfe1e8"
					})
				]
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_4485",
				"data-name": "Group 4485",
				transform: "translate(1360.69 453.826)",
				opacity: .5,
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_4484",
					"data-name": "Group 4484",
					transform: "translate(0)",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_4483",
						"data-name": "Group 4483",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_8099",
							"data-name": "Path 8099",
							d: "M545.43,107.58c-.685-16.955,13.526-24.487,28.057-24.487s30.344,3.765,31.714,26.31c.881,14.5-6.85,23.428-29.115,23.428-7.508,0-13.344-1.184-17.814-3.3l-11.129,9.889,5.469-13.669c-4.845-4.5-6.886-10.858-7.182-18.175",
							transform: "translate(-545.406 -83.093)",
							fill: "#899bfa"
						})
					})
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Sign",
				transform: "translate(1376.489 463.775)",
				children: [/* @__PURE__ */ _jsx("ellipse", {
					id: "Ellipse_70",
					"data-name": "Ellipse 70",
					cx: 14.132,
					cy: 14.132,
					rx: 14.132,
					ry: 14.132,
					transform: "translate(0)",
					fill: "#fff"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_1942",
					"data-name": "Path 1942",
					d: "M-1355.033,1278.213c2.364,0,1.948,2.126,2,2.3,0,1.346-.153,2.229-2.119,2.229-1.868,0-2.411-.441-2.411-2.3C-1357.565,1278.5-1356.85,1278.213-1355.033,1278.213Zm-.279-1.89c-1.831,0-2.131-.437-2.131-1.865v-7.68c0-1.394.292-1.914,2.156-1.914,1.909,0,2.132.56,2.132,1.938v7.68C-1353.155,1275.739-1353.3,1276.323-1355.312,1276.323Z",
					transform: "translate(1369.431 -1259.839)",
					fill: "#032478"
				})]
			})
		]
	})]
});
export default SvgNoNotificationSelected;
